"use client";

import React, { createContext, useCallback, useContext, useState } from "react";
import UsageLimitModal from "@/src/components/Popups/UsageLimitModal";

const UsageLimitContext = createContext(null);

export function UsageLimitProvider({ children }) {
  const [payload, setPayload] = useState(null);

  const open = useCallback((data) => {
    setPayload({
      tier: data?.tier === "pro" ? "pro" : "basic",
      resetAtUtc: data?.reset_at || null,
    });
  }, []);

  const close = useCallback(() => setPayload(null), []);

  return (
    <UsageLimitContext.Provider value={{ open, close, isOpen: !!payload }}>
      {children}
      <UsageLimitModal
        open={!!payload}
        closeModal={close}
        tier={payload?.tier || "basic"}
        resetAtUtc={payload?.resetAtUtc}
      />
    </UsageLimitContext.Provider>
  );
}

export function useUsageLimit() {
  const ctx = useContext(UsageLimitContext);
  if (!ctx) {
    return { open: () => {}, close: () => {}, isOpen: false };
  }
  return ctx;
}
